module.exports = __webpack_public_path__ + "static/img/bannericon.b0753389.png";